import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Sidebar'; // Sesuaikan path dengan project Anda
import { Link, useLocation, useNavigate } from 'react-router-dom';

// 4 Menu Utama yang langsung tampil di Bottom Nav saat Mobile
const primaryNavItems = [
  { 
    label: 'Dashboard', 
    path: '/pasien/', 
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} style={{ width: 22, height: 22 }}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    )
  },
  { 
    label: 'Daftar', 
    path: '/pasien/daftar-berobat', 
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} style={{ width: 22, height: 22 }}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
      </svg>
    )
  },
  { 
    label: 'Antrian', 
    path: '/pasien/antrian', 
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} style={{ width: 22, height: 22 }}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    )
  },
  { 
    label: 'Riwayat', 
    path: '/pasien/riwayat', 
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} style={{ width: 22, height: 22 }}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    )
  },
];

const PasienLayout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Deteksi ukuran layar secara real-time
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.clear(); // Bersihkan token/session
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div 
      className="admin-layout" 
      style={{
        ...styles.layout,
        paddingBottom: isMobile ? '65px' : '0px'
      }}
    >

      {/* DESKTOP SIDEBAR */}
      {!isMobile && <Sidebar />}

      {/* MAIN CONTENT Area Konten Utama */}
      <main 
        className="admin-content" 
        style={styles.content}
      >
        {children}
      </main>

      {/* ========================================== */}
      {/* MOBILE BOTTOM NAVIGATION BAR               */}
      {/* ========================================== */}
      {isMobile && (
        <nav style={styles.bottomNav}>
          {primaryNavItems.map((item, index) => {
            const active = isActive(item.path);
            return (
              <Link 
                key={index} 
                to={item.path} 
                style={{
                  ...styles.navLink,
                  color: active ? '#4f46e5' : '#64748b',
                  fontWeight: active ? '600' : '500'
                }}
              >
                <span style={{ color: active ? '#4f46e5' : '#94a3b8' }}>
                  {item.icon}
                </span>
                <span style={styles.navLabel}>{item.label}</span>
              </Link>
            );
          })}

          {/* Tombol Pemicu Sisa Menu (Pembayaran, Profil, Logout) */}
          <button 
            onClick={() => setShowMoreMenu(true)} 
            style={{
              ...styles.navLink,
              background: 'none',
              border: 'none',
              color: '#64748b',
              cursor: 'pointer'
            }}
          >
            <span style={{ color: '#94a3b8' }}>
              <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} style={{ width: 22, height: 22 }}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </span>
            <span style={styles.navLabel}>Menu</span>
          </button>
        </nav>
      )}

      {/* ========================================== */}
      {/* MOBILE DRAWER POPUP (Action Sheet)         */}
      {/* ========================================== */}
      {isMobile && showMoreMenu && (
        <>
          {/* Backdrop gelap klik untuk menutup */}
          <div style={styles.drawerBackdrop} onClick={() => setShowMoreMenu(false)} />
          
          {/* Kontainer Lembar Menu dari Bawah */}
          <div style={styles.drawerContainer}>
            <div style={styles.drawerHeader}>
              <h3 style={styles.drawerTitle}>Menu Pasien</h3>
              <button style={styles.drawerCloseBtn} onClick={() => setShowMoreMenu(false)}>✕</button>
            </div>
            
            <div style={styles.drawerGrid}>
              {/* Menu Pembayaran */}
              <Link to="/pasien/pembayaran" style={styles.drawerItem} onClick={() => setShowMoreMenu(false)}>
                <svg style={{ width: 24, height: 24, color: '#4f46e5' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
                <span style={{ marginTop: '4px' }}>Pembayaran</span>
              </Link>

              {/* Menu Profil */}
              <Link to="/pasien/profil" style={styles.drawerItem} onClick={() => setShowMoreMenu(false)}>
                <svg style={{ width: 24, height: 24, color: '#4f46e5' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span style={{ marginTop: '4px' }}>Profil</span>
              </Link>

              {/* Tombol Logout */}
              <button 
                onClick={() => { setShowMoreMenu(false); handleLogout(); }} 
                style={{ ...styles.drawerItem, ...styles.drawerLogout }}
              >
                <svg style={{ width: 24, height: 24 }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                <span style={{ marginTop: '4px' }}>Logout</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

/* ==========================================
   STYLING OBJEK (Proteksi Pembatas Lebar)
   ========================================== */
const styles = {
  layout: {
    display: 'flex',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
    position: 'relative',
    boxSizing: 'border-box'
  },
  content: {
    flex: 1,
    minWidth: 0,        // Mencegah flex-child melebar tak terkontrol menembus batas layar kiri/kanan
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  bottomNav: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: '65px',
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e2e8f0',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    zIndex: 9999,
    paddingBottom: 'env(safe-area-inset-bottom)',
    boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.05)'
  },
  navLink: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    fontSize: '11px',
    width: '20%',
    height: '100%',
    gap: '4px',
    padding: 0
  },
  navLabel: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  drawerBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.4)',
    zIndex: 10000
  },
  drawerContainer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: '#ffffff',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    padding: '24px 20px 40px 20px',
    zIndex: 10001,
    boxShadow: '0 -8px 24px rgba(0, 0, 0, 0.15)'
  },
  drawerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px'
  },
  drawerTitle: {
    margin: 0,
    fontSize: '16px',
    fontWeight: 600,
    color: '#1e293b'
  },
  drawerCloseBtn: {
    background: 'none',
    border: 'none',
    color: '#94a3b8',
    fontSize: '20px',
    cursor: 'pointer'
  },
  drawerGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px'
  },
  drawerItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    color: '#475569',
    fontSize: '12px',
    fontWeight: '500',
    padding: '12px',
    borderRadius: '12px',
    background: '#f8fafc',
    border: 'none',
    cursor: 'pointer'
  },
  drawerLogout: {
    color: '#ef4444',
    background: '#fef2f2'
  }
};

export default PasienLayout;